// 전자서명 이용약관
export const LATEST_ELECTRONIC_SIGNING_URL = 'https://www.modusign.co.kr/policy/electronic-signing';
// 전자서명 개인정보 수집 및 이용 동의
export const LATEST_ELECTRONIC_SIGNING_PERSONAL_DATA_AGREEMENT_URL =
  'https://www.modusign.co.kr/policy/electronic-signing-personal-data-agreement';
// 마케팅 정보 수신 동의
export const LATEST_MARKETING_AGREEMENT_URL =
  'https://www.modusign.co.kr/policy/marketing-agreement';
// 회원가입 개인정보 수집 및 이용 동의
export const LATEST_PERSONAL_DATA_AGREEMENT_URL =
  'https://www.modusign.co.kr/policy/personal-data-agreement';
// 개인정보처리방침
export const LATEST_PRIVACY_URL = 'https://www.modusign.co.kr/policy/privacy';
// 모두싸인 이용약관
export const LATEST_SERVICE_URL = 'https://www.modusign.co.kr/policy/service';
// 링크서명 서명자 개인정보처리방침
export const LATEST_CONTRACT_LINK_PRIVACY_URL =
  'https://www.modusign.co.kr/policy/contract-link-privacy';
// 링크서명 서명자 이용약관
export const LATEST_CONTRACT_LINK_SERVICE_URL =
  'https://www.modusign.co.kr/policy/contract-link-service';

// 대면서명 이용약관
export const LATEST_IN_PERSON_SIGNING_SERVICE =
  'https://www.modusign.co.kr/policy/in-person-signing';
